import { Controller } from "@hotwired/stimulus"

// 送付管理テーブルの列フィルタ。 各列の input / select 変更時に行を hide して絞り込む。
// - 氏名 / メール / プレースホルダー列: 部分一致 ( 大文字小文字無視 )
// - 送信状況 / 開封状況 / 参加意思: 完全一致 ( row の data-status / data-viewed / data-response と比較 )
// 「未応答」 は response_status が空 = data-response="__none__" を選ぶことで絞り込める。
export default class extends Controller {
  static targets = ["input", "row", "tbody", "emptyNotice", "count"]

  connect() {
    this.apply()
  }

  apply() {
    const filters = {}
    this.inputTargets.forEach(el => {
      const key = el.dataset.deliveryFilterColumnParam
      const value = el.value.trim()
      if (value) filters[key] = value.toLowerCase()
    })

    let visibleCount = 0
    this.rowTargets.forEach(row => {
      const cells = row.querySelectorAll("td")
      let match = true

      // 列インデックス: 0=振り直しID, 1=氏名, 2=メール, 3=送信状況, 4=開封状況, 5=参加意思, 6+ =プレースホルダー
      const PH_OFFSET = 6
      for (const [key, needle] of Object.entries(filters)) {
        if (key === "redistribution") {
          if (!cells[0]?.textContent.toLowerCase().includes(needle)) { match = false; break }
        } else if (key === "name") {
          if (!cells[1]?.textContent.toLowerCase().includes(needle)) { match = false; break }
        } else if (key === "email") {
          if (!cells[2]?.textContent.toLowerCase().includes(needle)) { match = false; break }
        } else if (key === "status") {
          if ((row.dataset.status || "") !== needle) { match = false; break }
        } else if (key === "viewed") {
          if ((row.dataset.viewed || "0") !== needle) { match = false; break }
        } else if (key === "response") {
          if ((row.dataset.response || "") !== needle) { match = false; break }
        } else if (key.startsWith("phdate_")) {
          // phdate_${i}_day / phdate_${i}_hour : cell hidden 値 ( YYYY-MM-DDTHH:MM ) と照合。
          // NOTE: cell 内には form_with 由来の hidden ( name="key" ) と datetime_field の値 hidden の 2 つがあるため、
          //       datetime_picker_target='hidden' で値側だけを取る。
          const m = key.match(/^phdate_(\d+)_(day|hour)$/)
          if (!m) continue
          const idx = PH_OFFSET + parseInt(m[1], 10)
          const kind = m[2]
          const value = cells[idx]?.querySelector("input[type='hidden'][data-datetime-picker-target='hidden']")?.value || ""
          if (!value) { match = false; break }
          const [datePart, timePart] = value.split("T")
          if (kind === "day" && datePart !== needle) { match = false; break }
          if (kind === "hour" && (timePart || "").slice(0, 2) !== needle) { match = false; break }
        } else if (key.startsWith("ph_")) {
          const idx = PH_OFFSET + parseInt(key.slice(3), 10)
          const cellText = cells[idx]?.textContent.toLowerCase() || ""
          // input / select の value も検索対象にする ( placeholder セルは form 要素で表示している )
          const controlText = Array.from(cells[idx]?.querySelectorAll("input, select") || [])
            .map(el => el.value || (el.tagName === "SELECT" ? el.options[el.selectedIndex]?.text : "") || "")
            .join(" ")
            .toLowerCase()
          if (!(cellText.includes(needle) || controlText.includes(needle))) { match = false; break }
        }
      }

      row.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    if (this.hasEmptyNoticeTarget) {
      this.emptyNoticeTarget.classList.toggle("hidden", visibleCount > 0)
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = `該当 ${visibleCount} 件 / 全 ${this.rowTargets.length} 件`
    }
  }
}
